import React from 'react';

const NoMatch = () => {
  return <div></div>;
};

export default NoMatch;
